<template>
  <div class="map__container">
    <FindOdpPanel
      :city="selectedCity"
      :absoluteUrl="absoluteUrl"
      :showLinkFindOffice="showLinkFindOffice"
      :linkFindOffice="linkFindOffice"
      :inter-refunds="interRefunds"
      @changeFilters="(e) => changeFilters(e)"
      @select="onCitySelect"
    >
      <template #map-result-odp>
        <div
          v-if="hideMapWithoutOdp"
          class="map-nav__item empty"
        >
          Ничего не
          найдено
        </div>
        <div
          v-else
          class="map-nav__item"
        >
          {{ titlePvz }}
        </div>
      </template>
      <template #map-tabs>
        <MapTabs
          :tab-active="deliveryLap ? 'deliveryLap' : 'receptionLap'"
          @changeTab="onChangeTab"
        />
      </template>
    </FindOdpPanel>

    <ODPPreviewModal
      class="map__container map__container_card"
      :hideODPPreview="hideODPPreview"
      :ODPPreview="ODPPreview"
      :buildRoute="buildRoute"
      :elementMap="this.$refs.ymapsView"
      :absoluteUrl="absoluteUrl"
      :showLinkToOffice="!absoluteUrl"
      v-if="ODPPreview !== null && desktopDevice"
    />
    <YmapsView
      style="width: 100%; height: 676px;"
      :showODPPreview="showODPPreview"
      :cityCode="code"
      ref="ymapsView"
      :selectedCity="selectedCity"
      :filter-params="filterParams"
      :reception-lap="receptionLap"
      :delivery-lap="deliveryLap"
      :inter-refunds="interRefunds"
      :hide-map-without-odp="hideMapWithoutOdp"
      @change-hide-map-without-odp="hideMapWithoutOdp = $event"
      @changeNgResults="ngResults = $event"
    />
    <ODPPreviewModal
      class="map__container map__container_card"
      :hideODPPreview="hideODPPreview"
      :ODPPreview="ODPPreview"
      :buildRoute="buildRoute"
      :elementMap="this.$refs.ymapsView"
      v-if="ODPPreview !== null && !desktopDevice"
    />
  </div>
</template>


<script>
import YmapsView from './YmapsView.vue';
import ODPPreviewModal from './ODPPreviewModal.vue';
import FindOdpPanel from '../FindOdp/FindOdpPanel.vue';

import { getters as cityGetters } from '../../store/city.store';
import { COUNTRY_CODES } from '../../helpers/constans';
import { actions as cityRepositoryActions } from '../../store/city.repository';
import MapTabs from '../mapComponent/MapTabs.vue';
import mapTabsMixin from '../../mixins/mapTabsMixin';
import num2str from '../../helpers/num2str';
import URL from '../../helpers/url';
import _ from "lodash";

export default {
  name: 'MapWidget',
  mixins: [mapTabsMixin],
  props: {
    msg: String,
    absoluteUrl: {
      type: String,
      default: '',
    },
    showLinkFindOffice: {
      type: Boolean,
      default: true,
    },
    linkFindOffice: {
      type: String,
      default: '',
    },
  },
  components: {
    MapTabs,
    YmapsView,
    ODPPreviewModal,
    FindOdpPanel,
  },
  computed: {
    ...cityGetters,
    selectedCity() {
      return this.userSelectedCity || { Code: cityGetters.code(), Name: cityGetters.name() };
    },
    countryCode() {
      if (!this.selectedCity || this.loadingCities) return '';
      const city = cityRepositoryActions.find(this.selectedCity.Code);
      if (city && city[0] && city[0].Country_code) {
        return city[0].Country_code;
      }
      return '';
    },
    filterParams() {
      return this.countryCode === COUNTRY_CODES.UZBEKISTAN ? 'deliveryLap=1' : 'filter=pip';
    },
    titlePvz() {
      return `${this.ngResults} ${num2str(this.ngResults, [' отделение', ' отделения', ' отделений'])}`;
    },
  },
  methods: {
    onCitySelect(city) {
      this.userSelectedCity = city;
    },
    hideODPPreview() {
      this.ODPPreview = null;
    },
    buildRoute(e, odp) {
      e.preventDefault();
      this.$refs.ymapsView.getUserLocation(odp);
    },
    showODPPreview(odp) {
      this.ODPPreview = odp.data;
      this.$bvModal.show('ODPPreviewModal');
    },
    filtered() {
      if (this.search.length) {
          const r = _.filter(this.cities, (v) => (v.Name.toLowerCase().includes(this.search.toLowerCase()))); // eslint-disable-line
        return r;
      }
      return this.cities;
    },
    num2str(n, text_forms) {
      n = Math.abs(n) % 100;
      const n1 = n % 10;
      if (n > 10 && n < 20) {
        return text_forms[2];
      }
      if (n1 > 1 && n1 < 5) {
        return text_forms[1];
      }
      if (n1 == 1) {
        return text_forms[0];
      }
      return text_forms[2];
    },
    async changeFilters(e) {
      try {
        this[e.target.id] = e.target.checked;
        await this.$nextTick();
      } catch (err) {
        console.error(err)
      }
      if (this[e.target.id]) {
        this.queryString.push(e.target.id);
      } else {
        const index = this.queryString.indexOf(e.target.id);
        if (index > -1) {
          this.queryString.splice(index, 1);
        }
      }
      this.updateFilterUrl();
    },
    /**
     * Возвращает массив с параметрами фильтра, кроме тех, значения которых соответствуют значениям по умолчанию
     *
     * @return Array
     */
    getFilterQueryParams() {
      const params = [];

      if (this.isOpenOnWeekends === true) { params.push(`isOpenOnWeekends=${1}`); }
      if (this.acquiring === true) { params.push(`acquiring=${1}`); }
      if (this.interRefunds === true) { params.push(`interRefunds=${1}`); }
      if (this.interShipping === true) { params.push(`interShipping=${1}`); }
      if (this.receptionLap === true) { params.push(`receptionLap=${1}`); }
      if (this.searchQueryODP && this.searchQueryODP.length) { params.push(`Search=${this.searchQueryODP}`); }
      params.push(this.showList ? 'view=list' : 'view=map');

      return params;
    },
    updateFilterUrl() {
      const queryParams = this.getFilterQueryParams();

      window.history.pushState(window.location.origin, null, `?${queryParams.join('&')}`);

      // // После изменения фильтров, обновим данные query параметров, для возврата в исходной состояние.
      // this.setQueryParamsForODPPage(this.cityCodeLocal);
    },
  },
  mounted() {
    const self = this;
    if (this.$root.eventHub) {
      this.$root.eventHub.$on('showODPPreview', (boolean) => {
        if (!boolean) {
          self.$bvModal.hide('ODPPreviewModal');
          self.ODPPreview = null;
        }
      });
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1050) {
        this.desktopDevice = true;
      } else {
        this.desktopDevice = false;
      }
    });

    const url = new URL(window.location.href);
    _.forEach(url.searchParams, (param, key) => {
      if (key === 'view' && param === 'list') {
        self.showList = true;
      }

      if (key === 'Search') {
        self.searchQueryODP = param;
      }

      if (key === 'acquiring') {
        self.acquiring = param === '1';
      }

      if (key === 'isOpenOnWeekends') {
        self.isOpenOnWeekends = param === '1';
      }

      if (key === 'interShipping') {
        self.interShipping = param === '1';
      }

      if (key === 'interRefunds') {
        self.interRefunds = param === '1';
      }
    });
  },
  data() {
    return {
      ODPPreview: null,
      showList: true,
      userSelectedCity: null,
      desktopDevice: window.innerWidth >= 1050,
      hideMapWithoutOdp: false,
      ngResults: 0,
      interRefunds: false,
      queryString: [],
    };
  },
  watch: {
    selectedCity(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.hideODPPreview();
      }
    },
  },
};
</script>
